module.exports = __webpack_public_path__ + "assets/img/block-right-2a21a2f6.png";